import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {earnedDaysUtil} from '/component/partial/report/EarnedCABDays/EarnedDays.util';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './CabEarnedDays.style';

interface CabEarnedDaysProps {
  tt: (key: string, value: string) => string;
  item: {
    earnedCabOn?: string | object;
  };
}

export const CabEarnedDays: React.FC<CabEarnedDaysProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}) => {
  const earnedCabOn = get(item, 'earnedCabOn', {});
  return (
    <View style={styles.inline}>
      <Text testID={Reports.reportQsbEarnedDaysAgo}>
        {tt('earnedCabDays', 'Earned')}{' '}
        {earnedDaysUtil({earnedOn: earnedCabOn, tt})}
      </Text>
    </View>
  );
};

export const CabEarnedDaysConnected = withTranslation(
  'report.record.CabEarnedDays',
)(CabEarnedDays);
